<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_WriteOffList')"
    width="740px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view settlement-notice"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <div style="width: 100%">
          <div class="form-row">
            <el-form
              label-position="left"
              :inline="true"
              label-width="75px"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
                <el-select v-model="filter.officeId" style="width: 200px" :allow-create="true" no="1">
                  <el-option
                    v-for="(item,index) in offices"
                    :key="index"
                    :label="$getLangColumn(item)"
                    :value="item.officeId"
                  />
                </el-select>
              </el-form-item>
              <el-button v-show="$checkPermission(['tab_BillOverseasSCenter_cancelClearAmount'])" no="2" @click="cacelClearBtn_clickHandler()">{{ $t('CargoMsg.Cargo_CancelWriteOff') }}</el-button>
            </el-form>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015206"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <span>{{ $t('CargoMsg.Cargo_TotalWriteOffsP') }}</span>
      <span>{{ rmbTotal }}</span>
      <span>Debit:</span>
      <span>{{ usdTotal }}</span>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import { cancelClearHistory } from '@/api/clearing/actualAmount'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryActualAmountsByID } from '@/api/act/writeoff'
import { LOG_OVERSEAS_SETTLEMENT_CENTER } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'BillActualAmountDetailWindow',
  components: { CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    actualAmount: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      filter: {
        officeId: 0,
        se: false,
        ae: false
      },
      offices: [],
      rmbTotal: 0,
      usdTotal: 0,
      officeAmounts: [], // 相同分公司数据
      officeGridDatas: [], // 分公司详细数据
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      dialog: {
        visible: false,
        content: ''
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', colId: 'billingNo', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'businessDate', colId: 'businessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', colId: 'chargeItemId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_BranchCompany'), field: 'branchId', colId: 'branchId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffCurrency'), field: 'clearCurrency', colId: 'clearCurrency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), field: 'clearAmount', colId: 'clearAmount', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChargeOriginalCurrency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_ChargeOriginalAmount'), field: 'amount', colId: 'amount', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'), field: 'ar', colId: 'ar', width: 200,
          valueFormatter: (params) => {
            return this.isAreLabFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementStatus'), field: 'confirmState', colId: 'confirmState', width: 200,
          valueFormatter: (params) => {
            return this.confirmStateLabFun(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', colId: 'remark', width: 200 }
      ],
      location: LOG_OVERSEAS_SETTLEMENT_CENTER.code
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  mounted() {
    this.getOffices()
    this.loadClearHistory()
  },
  methods: {
    getOffices() {
      this.offices = []
      const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      this.getOfficeItem('全部', 'All', 0)
      for (const office of officeList) {
        this.getOfficeItem(office.chineseName, office.englishName, office.officeId)
      }
    },
    getOfficeItem(chineseName, englishName, officeId) {
      const office = {
        chineseName: chineseName,
        englishName: englishName,
        officeId: officeId
      }
      this.offices.push(office)
    },
    // 查询销账明细
    loadClearHistory() {
      queryActualAmountsByID([this.actualAmount.uuid]).then(res => {
        const result = res.data
        if ((!result || result.length === 0)) {
          for (const o in result) {
            if (o.isAr) {
              o.amountDebit = o.amount
              o.clearAmountDebit = o.amount
            } else {
              o.amountCredit = o.amount
              o.clearAmountCredit = o.amount
            }
          }
        }
        this.rowData = result
        this.updateTotals()
      })
    },
    applyFilter(value) {
      const newRowData = this.rowData.filter(item => item.branchId === value)
      this.rowData = newRowData
    },
    updateTotals() {
      let creditTotal = 0
      let debitTotal = 0
      for (const item of this.rowData) {
        if (!isNaN(item.amountCredit)) { creditTotal += item.clearAmountCredit }
        if (!isNaN(item.amountDebit)) { debitTotal += item.clearAmountDebit }
      }
      this.rmbTotal = creditTotal.toFixed(2)
      this.usdTotal = debitTotal.toFixed(2)
    },
    onCancel() {
      this.$emit('close')
    },
    confirmStateLabFun(value) {
      if (value === 0) return this.$t('CargoMsg.Cargo_NotSent')
      if (value === 1) return this.$t('CargoMsg.Cargo_Sent')
      if (value === 2) return this.$t('CargoMsg.Cargo_Confirmed')
      return ''
    },
    isAreLabFun(value) {
      return value ? this.$t('CargoMsg.Cargo_Revenue') : this.$t('CargoMsg.Cargo_Expenditure')
    },
    cacelClearBtn_clickHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectWriteOffDetails'))
        return
      }
      if (!this.getClearhistoryIsSend(selectedRows)) {
        this.$confirm(this.$t('CargoMsg.Cargo_SureToCancel'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const clearHistoryKeys = this.getClearHistoryKey(selectedRows)
          this.fullscreenLoading = getLoading()
          cancelClearHistory(clearHistoryKeys, this.actualAmount.uuid, this.location).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_CancelSuccessfully'))
            this.gridOptions.api.updateRowData({ 'remove': selectedRows })
          })
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    getClearhistoryIsSend(selectedItems) {
      for (const item of selectedItems) {
        if (Number(item.confirmState) !== 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_JobNo') + item.jobNo +
            '\n' + this.$t('CargoMsg.Cargo_BillNoP') +
            item.billingNo + '\n' + this.$t('CargoMsg.Cargo_WriteOffAmountIs') +
            item.clearAmount + item.clearCurrency + '\n' + this.$t('CargoMsg.Cargo_ASCCCTBC'))
          return true
        }
      }
      return false
    },
    getClearHistoryKey(selectedItems) {
      const ids = []
      for (const item of selectedItems) {
        ids.push(item.clearHistoryKey)
      }
      return ids
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .settlement-notice{
    .el-checkbox{
      margin-top: 6px;
    }
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
